import { getAuthAxiosBackend } from "../helpers/axios"

class ResidentialCardServices{

    get(id){
        return getAuthAxiosBackend().get('ResidentialCards/getResidentialCards/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('ResidentialCards/getResidentialCardsByPersonId/' + personId)
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('ResidentialCards/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('ResidentialCards/addResidentialCards', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('ResidentialCards/updateResidentialCards/' + id, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('ResidentialCards/softDeleteResidentialCards/' + id.toString())
    }
}

export default new ResidentialCardServices()